<!-- Page Wrapper -->

<div class="content container-fluid">
    <div class="bg-white page-border" style="padding:30px;">
        <!--page body contant -->

        <!--header row-->
        <div class="row row-replace add-m-b">
            <!-- header  -->
            <div class="col-12 col-p text-center">
                <div class="row">
                    <div class="col-8 col-md-10">
                        <img src="assets/img/logo.png" class="mb-5" width="180">
                    </div>
                    <div class="col-4 col-md-2" *ngIf="empStatus == 'ex' || empStatus == ''">
                        <button class="btn btn-sm btn-danger" (click)="logout()">
                         LogOut
                        </button>
                    </div>
                </div>
                <hr/>
                <!-- <div class="row">
                    <div class="col-12">   
                        <iframe
                            style="height: 350px !important"
                            width="100%"
                            class="border-0 border-up-down"
                            src="https://www.youtube.com/embed/0dHcFbOVwjU"
                        >
                        </iframe>
                    </div>
                </div> -->
                <hr/>
                <div class="row">
                    <div class="col-10">
                        <h2>Mobilise Job Portal </h2>
                    </div>
                    <div class="col-2" *ngIf="empStatus == 'ex'">
                        <button class="btn btn-sm btn-primary" (click)="queryModal()">Queries</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <section class="col-md-12">
                <form (ngSubmit)="searchJobs()" [formGroup]="searchJobForm">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card dash-widget card-mb">
                                <div class="text-left  card-pn">
                                    <h4 class="mb-0 pl10 add-p-tb5">Job Search</h4>
                                    <div class="add-p10">
                                        <div class="row">
                                            <!-- <div class="col-md-4 mb7">
                                                <select2 [data]="ccList" placeholder="Cost Center" value="value" formControlName="cost_center">
                                                </select2>
                                            </div> -->
                                            <div class="col-md-3 mb7 form-group">
                                                <label>Select Region </label>
                                                <select class="form-control" formControlName="region">
                                                    <option value="">All Region</option>
                                                    <option value={{rgn.value}} *ngFor="let rgn of regionAll">{{rgn.label}}</option>
                                                </select>
                                            </div>
                                            <div class="col-md-3 mb7 form-group">
                                                <label>Search By Designation </label>
                                                <input type="text" class="form-control" formControlName="design" placeholder="Designation" />
                                                <!-- <input list="designation" autocomplete="off" class="form-control" placeholder="Designation">
                                                <datalist id="designation">
                                                        <option [value]="item.value" *ngFor="let item of degsnList;">{{item.label}}</option>
                                                    </datalist> -->
                                            </div>
                                            <!-- <div class="col-md-3 mb7 form-group">
                                                <label>Select Skill </label>
                                                <select class="form-control" formControlName="skill_type">
                                                    <option value="">Select Skill</option>
                                                    <option value="{{item.value}}" *ngFor = "let item of skillList">{{item.label}}</option>
                                                </select>
                                            </div> -->

                                            <div class="col-md-3 mb7 form-group">
                                                <label>Select State </label>
                                                <select class="form-control" formControlName="state" (change)="getStateCity($event)">
                                                    <option value="">Select State</option>
                                                    <option value="{{item.st_id}}" *ngFor = "let item of stateList">{{item.st_name}}</option>
                                                </select>
                                            </div>
                                            <div class="col-md-3 mb7 form-group">
                                                <label>Select City </label>
                                                <select class="form-control" formControlName="city">
                                                    <option value="">Select City</option>
                                                    <option value="{{item.ct_id}}" *ngFor="let item of cityList">{{item.ct_name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row">

                                            <div class="col-md-12 mb7 col-xs-12 text-center">
                                                <button class="btn btn-sm btn-success">Search</button>
                                                <button type="button" (click)="resetIJPFilter()" class="btn btn-sm btn-danger ml-10">Reset</button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>


        <ul class="nav nav-tabs nav-tabs-bottom">
            <!-- <li class="nav-item" *ngIf="empEntity != '2' && empStatus != null" (click)="changeEvent('a')"><a class="nav-link " [ngClass]="tabs.a == true ? 'active':''" href="#ijp-tab1" data-toggle="tab"><i class="fa fa-briefcase"></i> Regular Jobs</a></li>
            <li class="nav-item" *ngIf="empStatus == '' || empStatus == null || empStatus == 'ex'" (click)="changeEvent('b')"><a class="nav-link" [ngClass]="tabs.b == true ? 'active':''" href="#ijp-tab2" data-toggle="tab"><i class="fa fa-briefcase"></i> FTC Jobs</a></li> -->

            <li class="nav-item" *ngIf="empStatus == '' || empStatus == null || empStatus == 'ex'" (click)="changeEvent('a')"><a class="nav-link" [ngClass]="tabs.a == true ? 'active':''" href="#-tabijp2" data-toggle="tab"><i class="fa fa-briefcase"></i> FTC Jobs</a></li>
            <li class="nav-item" *ngIf="empStatus == '' || empStatus == null || empStatus == 'ex'" (click)="changeEvent('b')"><a class="nav-link " [ngClass]="tabs.b == true ? 'active':''" href="#ijp-tab1" data-toggle="tab"><i class="fa fa-briefcase"></i> Regular Jobs</a></li>
        </ul>
        <!-- [ngClass]="activeTabR == true ? 'active':''" -->
        <div class="tab-content m-t-10">
            <!--FTC tab-->
            <nav class="tab-pane" [ngClass]="tabs.a == true ? 'active':''" id="ijp-tab2">
                <div class="row row-replace">
                    <div class="col-12">
                        <!-- <p>FTC tab</p> -->
                        <div class="row pagination-padding">
                            <div class="col-md-2 form-inline">
                                <label for="itemperpage">Items Per Page</label>
                                <select name="itemperpage" id="itemperpage" class="form-control ml-10" (change)="getNumberPerPageF($event)">
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="200">200</option>
                                </select>
                            </div>
                            <div class="col-md-7">
                            </div>
                            <div class="col-md-3">
                            </div>
                        </div>
                        <!--card list -->
                        <div class="row row-replace" *ngFor="let list of ijpListFTC | paginate: {id: 'ftc_jobs',itemsPerPage: pageSizeF, currentPage: pageF, totalItems: countF};let i = index;">
                            <div class="col-12 bg-primary blank-row"></div>
                            <div class="col-md-12 col-12 card">
                                <div class="container-fluid">
                                    <div class="row link-chan">
                                        <section class="col-md-9 col-xs-6 all-m-b0">
                                            <a href="javascript:void(0);" [routerLink]="['/jobs/'+list.mrf_id]">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <h3>{{list.ijp_code}} : {{list.desig_desc}} ,&nbsp; <b>Designation</b> : {{list.desig_desc}}</h3>
                                                    </div>
                                                    <!-- <div class="col-md-6">

                                </div> -->
                                                </div>
                                                <ul class="job-post-det">
                                                    <li class="m-b-0"><i class="fa fa-calendar"></i> Posted Date: <span class="text-blue">{{list.created_at}}</span></li>
                                                    <!-- <li class="m-b-0"><i class="fa fa-calendar"></i> Last Date: <span class="text-blue">{{list.reqd_by}}</span></li> -->
                                                </ul>
                                                <h4> <i class="fa fa-briefcase m-r-5"></i> <span class="m-r-10"> {{list.exp_frm}} - {{list.exp_to}} years </span> <i class="fa fa-credit-card m-r-5"></i>
                                                    <!-- <span> Rs {{ list.est_bgdt_frm | number:'1.0':'en-US' }}</span> -->
                                                    <span *ngIf="checkBugetfrom(list.est_bgdt_frm) == true">
                                                        {{list.est_bgdt_frm | number:'1.0':'en-US' }}
                                                    </span>
                                                    <span *ngIf="checkBugetfrom(list.est_bgdt_frm) == false">
                                                        {{list.est_bgdt_frm }}
                                                    </span>

                                                </h4>
                                                <h4><i class="fa fa-map-marker m-r-5"></i> Location : {{list.cost_center}} , {{list.ct_name}} , {{list.st_name}}</h4>
                                                <a href="javascript:void(0);" class="text-primary" [routerLink]="['/jobs/'+list.mrf_id]"><b>Read more </b> &nbsp;<i class="fa fa-arrow-right m-r-5"></i></a>
                                            </a>
                                        </section>
                                        <section class="col-md-3 col-xs-6 m-t-5">
                                            <div class="container-fluid">
                                                <div class="row">
                                                    <div class="col-9"><i class="fa fa-users m-r-5"></i> Total Applications</div>
                                                    <div class="col-3 text-blue top-corner-items h4">{{list.applicants}}</div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-9"><i class="fa fa-eye m-r-5"></i> Views</div>
                                                    <div class="col-3 text-blue top-corner-items h4">{{list.views}}</div>
                                                </div>
                                                <div class="row" *ngIf="list.gend_id == 2">
                                                    <div class="col-9"> <i class="fa fa-female"></i> Prefered Gender : {{list.gender}}
                                                    </div>
                                                    <div class="col-3 top-corner-items h4">

                                                        <i class="fa fa-female"></i></div>
                                                </div>
                                                <div class="row" *ngIf="list.attachment">
                                                    <div class="col-9"><i class="fa fa-info-circle" aria-hidden="true"></i> Job Description</div>
                                                    <div class="col-3 top-corner-items h4">
                                                        <a [href]="list.attachment" target="_blank" >
                                                            <i class="fa fa-download"></i></a>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-9"><i class="fa fa-file-text" aria-hidden="true"></i> Policy</div>
                                                    <div class="col-3 top-corner-items h4">
                                                        <a [href]="list.policy" target="_blank" download="">
                                                            <i class="fa fa-download"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row pagination-padding">
                            <div class="col-md-6">
                                Showing {{fromF}} - {{toF}} of {{countF}} entries
                            </div>
                            <div class="col-md-6">
                                <div class="text-right">
                                    <pagination-controls previousLabel="Prev" nextLabel="Next" responsive="true" (pageChange)="handlePageChangeF($event)" id="ftc_jobs"></pagination-controls>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            <!--regular tab-->
            <nav class="tab-pane" [ngClass]="tabs.b == true ? 'active':''" id="ijp-tab1">
                <div class="row row-replace">
                    <div class="col-12">
                        <!-- <p>Regular Tab</p> -->
                        <div class="row pagination-padding">
                            <div class="col-md-2 form-inline">
                                <label for="itemperpage">Items Per Page</label>
                                <select name="itemperpage" id="itemperpage" class="form-control ml-10" (change)="getNumberPerPage($event)">
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="200">200</option>
                                </select>
                            </div>
                            <div class="col-md-7">
                            </div>
                            <div class="col-md-3">
                            </div>
                        </div>
                        <!--card list -->
                        <div class="row row-replace" *ngFor="let list of ijpListReular | paginate: {id: 'regular_jobs',itemsPerPage: pageSize, currentPage: page, totalItems: count};let i = index;">
                            <div class="col-12 bg-primary blank-row"></div>
                            <div class="col-md-12 col-12 card">
                                <div class="container-fluid">
                                    <div class="row link-chan">
                                        <section class="col-md-9 col-xs-6 all-m-b0">
                                            <a href="javascript:void(0);" [routerLink]="['/jobs/'+list.mrf_id]">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <h3>{{list.ijp_code}} : {{list.desig_desc}} ,&nbsp; <b>Designation</b> : {{list.desig_desc}}</h3>
                                                    </div>
                                                </div>
                                                <ul class="job-post-det">
                                                    <li class="m-b-0"><i class="fa fa-calendar"></i> Posted Date: <span class="text-blue">{{list.created_at}}</span></li>
                                                    <!-- <li class="m-b-0"><i class="fa fa-calendar"></i> Last Date: <span class="text-blue">{{list.reqd_by}}</span></li> -->
                                                </ul>
                                                <h4> <i class="fa fa-briefcase m-r-5"></i> <span class="m-r-10"> {{list.exp_frm}} - {{list.exp_to}} years </span> <i class="fa fa-credit-card m-r-5"></i>
                                                    <!-- <span> Rs {{ list.est_bgdt_frm | number:'1.0':'en-US' }}</span> -->
                                                    <!-- <span *ngIf="checkBugetfrom(list.est_bgdt_frm) == true">
                                                        {{list.est_bgdt_frm | number:'1.0':'en-US' }}
                                                    </span>
                                                    <span *ngIf="checkBugetfrom(list.est_bgdt_frm) == false">
                                                        {{list.est_bgdt_frm }}
                                                    </span> -->
                                                </h4>
                                                <h4><i class="fa fa-map-marker m-r-5"></i> Location : {{list.cost_center}} , {{list.ct_name}} , {{list.st_name}}</h4>
                                                <a href="javascript:void(0);" class="text-primary" [routerLink]="['/jobs/'+list.mrf_id]"><b>Read more </b> &nbsp;<i class="fa fa-arrow-right m-r-5"></i></a>
                                            </a>
                                        </section>
                                        <section class="col-md-3 col-xs-6 m-t-5">
                                            <div class="container-fluid">
                                                <div class="row">
                                                    <div class="col-9"><i class="fa fa-users m-r-5"></i> Total Applications</div>
                                                    <div class="col-3 text-blue top-corner-items h4">{{list.applicants}}</div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-9"><i class="fa fa-eye m-r-5"></i> Views</div>
                                                    <div class="col-3 text-blue top-corner-items h4">{{list.views}}</div>
                                                </div>
                                                <div class="row" *ngIf="list.gend_id == 2">
                                                    <div class="col-9"> <i class="fa fa-female"></i> Prefered Gender : {{list.gender}}
                                                    </div>
                                                    <div class="col-3 top-corner-items h4">

                                                        <i class="fa fa-female"></i></div>
                                                </div>
                                                <div class="row" *ngIf="list.attachment">
                                                    <div class="col-9"><i class="fa fa-info-circle" aria-hidden="true"></i> Job Description</div>
                                                    <div class="col-3 top-corner-items h4">
                                                        <a [href]="list.attachment" target="_blank" >
                                                            <i class="fa fa-download"></i></a>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-9"><i class="fa fa-file-text" aria-hidden="true"></i> Policy</div>
                                                    <div class="col-3 top-corner-items h4">
                                                        <a [href]="list.policy" target="_blank" download="">
                                                            <i class="fa fa-download"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row pagination-padding">
                            <div class="col-md-6">
                                Showing {{from}} - {{to}} of {{count}} entries
                            </div>
                            <div class="col-md-6">
                                <div class="text-right">
                                    <pagination-controls previousLabel="Prev" nextLabel="Next" responsive="true" (pageChange)="handlePageChange($event)" id="regular_jobs"></pagination-controls>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

        </div>


        <!--end page body contant -->
    </div>
</div>

<!-- /Page Wrapper -->

<!-- Start Modal -->
<div id="show_quer_modal" class="modal  custom-modal fade" role="dialog">
    <div class="modal-dialog   modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title"> Create Query</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <!-- <form [formGroup]="empSkillForm" (ngSubmit)="onSubmitEmpSkills()" class="horizontal-form" method="post" enctype="multipart/form-data"> -->
            <div class="modal-body">
                <!-- <app-query></app-query> -->
            </div>

            <div class="modal-footer">

            </div>
            <!-- </form> -->

        </div>
    </div>
</div>
<!-- /end Modal -->
